import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=An%20artistic%20abstract%20manga%20themed%20background%20with%20flowing%20ink%20strokes%20and%20dynamic%20comic%20panel%20grids%2C%20warm%20coral%20and%20amber%20gradients%20with%20subtle%20manga%20speech%20bubble%20textures%2C%20modern%20minimalist%20aesthetic%2C%20no%20characters%2C%20abstract%20artistic%20composition%20with%20Japanese%20wave%20patterns&width=1600&height=800&seq=hero-bg-manga&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-8 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide">
          女神漫画
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          聚焦<strong>韩漫</strong>、<strong>日漫</strong>、<strong>国漫</strong>热门推荐，提供排行榜精选、免费全集下拉式在线阅读，支持追更与收藏，尽享漫画大全
        </p>

        <div className="max-w-xl mx-auto flex items-center gap-3">
          <div className="relative flex-1">
            <input
              type="text"
              placeholder="搜索你喜欢的漫画..."
              className="w-full h-12 pl-5 pr-12 rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-white/40 focus:bg-white/20 transition-all"
            />
            <button className="absolute right-1.5 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 text-white transition-colors cursor-pointer">
              <i className="ri-search-line"></i>
            </button>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mt-5">
          <span className="text-white/50 text-xs">热门搜索：</span>
          {['修罗武神', '我独自升级', '斗罗大陆', '社内恋爱', '全知读者视角'].map((tag) => (
            <Link
              key={tag}
              to="/search"
              className="text-xs text-white/70 hover:text-white bg-white/10 hover:bg-white/20 px-3 py-1 rounded-full transition-all cursor-pointer"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center pt-2">
          <div className="w-1 h-2.5 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}